import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {DataService} from '../data.service';
import {RatesSroOriginDestination, StateCountry} from '../../shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class RatesSroOriginDestinationService extends DataService {

  private baseURI = this.apiUri + '';

  constructor(http: HttpClient) {
    super(http);
  }

  // Purpose of this function is to get List of
  getOriginDestination(sroMasterId: number): Observable<RatesSroOriginDestination[]> {
    this.setUri(this.baseURI + '/ratessroorigindestination/' + sroMasterId + '/sroMasterid');
    return this.get().pipe(catchError(this.handleError));
  }

  deleteOrigin(sroMasterId: number, originCity: string): Observable<any> {
    this.setUri(this.baseURI + '/ratessroorigindestination/' + sroMasterId + '/sroMasterid/' + originCity + '/origincity');
    return this.update(null);
  }

  deleteDestination(sroMasterId: number, destinationCity: string): Observable<any> {
    this.setUri(this.baseURI + '/ratessroorigindestination/' + sroMasterId + '/sroMasterid/' + destinationCity + '/destinationcity');
    return this.update(null);
  }

  getOriginStateCountryBySroMasterId(sroMasterId: number): Observable<StateCountry[]> {
    this.setUri(this.baseURI + '/ratessroorigindestination/getStateCountrybyoriginid/' + sroMasterId + '/sroMasterids');
    return this.get().pipe(catchError(this.handleError));
  }
  getFrtGlobalUpdateRecordsByOrigin(rateTypeId, carrierId, sroMasterId, originId, rateBidCyclesId) {
    /*http://localhost:8380/tmssserver/api/public/ratesfrt/currentDestinationCount/19/461/54/2/78*/
    this.setUri(this.baseURI + '/ratesfrt/currentDestinationCount/' + rateTypeId + '/' + carrierId + '/' + sroMasterId + '/' + originId + '/' + rateBidCyclesId);
    return this.get().pipe(catchError(this.handleError));
  }

  getFrtGlobalUpdateRecordsByOriginBySros(rateTypeId, carrierId, sroMasterId, originId, rateBidCyclesId) {
    /*http://localhost:8380/tmssserver/api/public/ratesfrt/currentDestinationCount/19/461/54/2/78*/
    this.setUri(this.baseURI + '/ratesfrt/currentDestinationCounts/' + rateTypeId + '/' + carrierId + '/' + sroMasterId + '/' + originId + '/' + rateBidCyclesId);
    return this.get().pipe(catchError(this.handleError));
  }

}
